export default __webpack_public_path__ + "static/media/ic_blue_trangle.3a9f7117.svg";